<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <!-- Page Title Section -->
  <div class="page-title-section">
    <h2>Assurance Mutuelle Santé Internationale</h2>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <p>
      Si vous êtes à la recherche de ce type d'assurance <span class="text-purple">Mutuelle Santé Internationale</span>, merci de prendre contact avec nous car il existe trop de <span class="text-purple">déclinaisons selon votre situation personnelle</span>.
    </p>
    <p>
      Si votre voyage de plus de 3 mois se fait dans le cadre de votre activité professionnelle, alors il est sans doute plus opportun d'aller à la page <a routerLink="/assurance-mutuelle-sante-internationale-professionnelle" class="link-purple">assurance Mutuelle Santé Internationale Professionnelle</a>.
    </p>
    <p>
      La mutuelle santé internationale est un complément nécessaire à l'<span class="text-purple">assurance voyage personnel</span>, accessible ici, qui lui ne prend pas en charge les soins qu'en cas d'accident.
    </p>
    <p>
      Le courtier en Assurance <span class="text-purple">BROKINS</span> est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <span class="text-purple">GENERALI, APRIL, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, POP SANTE, HENNER, AVENIR MUTUELLE, UCR, PRAECONIS…</span>
    </p>
  </div>

  <!-- Contact Button -->
  <div class="contact-button-wrapper">
    <button class="btn-contact" (click)="navigateToComparison()">
      Contactez-nous
    </button>
  </div>

</app-page-layout>


